import _ from 'lodash';
var _deeply = function deeply(mapped, fn) {
  return function (target) {
    if (_.isArray(target)) {
      return target.map(function (value) {
        return _deeply(mapped, fn)(value);
      });
    }
    if (_.isPlainObject(target)) {
      return mapped(_.mapValues(target, function (value) {
        return _deeply(mapped, fn)(value);
      }), fn);
    }
    return target;
  };
};
export { _deeply as deeply };
export var camelCaseKeys = function camelCaseKeys(object) {
  return _deeply(_.mapKeys, function (value, key) {
    return _.camelCase(key);
  })(object);
};
export var pascalCaseKeys = function pascalCaseKeys(object) {
  return _deeply(_.mapKeys, function (value, key) {
    return key.charAt(0).toUpperCase() + _.camelCase(key).slice(1);
  })(object);
};